<template src="./actionable-rating-stars.html"></template>

<script lang="ts">
export default {
  data() {
    return { hoverRating: 0 }
  },
  props: {
    modelValue: { // rating, set via v-model
      type: Number,
      default: 0
    },
    starSize: {
      type: String,
      default: 'xxl'
    }
  },
  emits: ['update:modelValue'],
  computed: {
    rating() {
      return this.hoverRating || this.modelValue
    }
  },
  methods: {
    ratingSelected(rating) {
      this.$emit('update:modelValue', rating)
    },
    ratingEnter(rating) {
      this.hoverRating = rating
    },
    ratingLeave() {
      this.hoverRating = 0
    }
  }
}
</script>

<style lang="scss" src="./rating-stars.scss"></style>
